import {
  Component, EventEmitter, Input, OnInit, Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import Course from '../../course.class';
import { VerificationComponent } from 'src/app/components/verification/verification.component';

@Component({
  selector: 'app-general-info',
  templateUrl: './general-info.component.html',
  styleUrls: [ './general-info.component.scss' ],
})
export class GeneralInfoComponent {
  @Output() stepForward = new EventEmitter<boolean>();
  @Output() stepBack = new EventEmitter<any>();
  @Output() closeDialogEmitter = new EventEmitter<any>();
  @Input() courseTypes: any;
  @Input() course: Course;
  @Input() isEditMode: any;
  @Input() isDuplicateCourse: any;
  @Input() isCourseRequestApproval: any;

  constructor(public dialog: MatDialog) {
  }

  updateCourseParameter = (
    event: any, parameter: keyof Course, type?: string,
  ) => {
    if (parameter === 'courseDescription') {
      return this.course.setProperty(parameter, event);
    }
    if (parameter === 'courseType') {
      const selectedType = this.courseTypes.find((courseType: any) => courseType.courseType === event?.target?.value);
      this.course.setProperty('courseType', selectedType);
      this.course.setProperty('courseTypeId', selectedType?.id);
      return
    }
    if (parameter === 'courseSize') {
      return this.course.setProperty(parameter, Number(event?.target?.value));
    }

    this.course.setProperty(parameter, event?.target?.value);
  }

  makePositive = () => {
    // this.course.creditHours = Math.abs(this.course.creditHours)
  }

  updateCourse = () => {
    if (this.course.courseName === '' ||  this.course.trackingValue === '' ||  this.course.courseType === '' ||  !this.course.courseSize ||  this.course.courseDescription === '') {
      return
    }
    this.stepForward.emit(true);
  }

  confirmInactive = (e: Event) => {
    const target = e.target as HTMLInputElement;
    const isChecked = target.checked;

    if (!isChecked && this.isEditMode) {
      const confirmDialogRef = this.dialog.open(VerificationComponent, {
        data: {
          type: 'alert',
          title: 'Are you sure you want to set this session to Inactive?',
          text: 'Users will be unregistered and the session will be removed and will not return upon course reactivation. This action CANNOT BE UNDONE. If you are trying to HIDE the course from the catalog, please adjust or remove the Course Availability instead.',
          confirmButtonTitle: 'Yes, cancel registrations and set course to inactive',
          cancelButtonTitle: 'No, keep it active',
          confirmButtonClass: 'red',
        },
      })

      confirmDialogRef.afterClosed().subscribe((result) => {
        if (result === 'verified') {
          this.course.setProperty('courseActiveFlag', false);
        } else {
          this.course.setProperty('courseActiveFlag', true);
          target.checked = true;
        }
      });
    }


  }

  closeDialog = () => {
    this.closeDialogEmitter.emit();
  }

}
